import { get } from 'lodash';

import { FIELD_PATHS, GOVERNMENT_RETIREMENT_AGE, REPAYMENT_OPTIONS } from '@funnels/constants';
import { AnyFormValues, FinancialSituation, RepaymentOptions } from '@funnels/types';
import { initialFormValues } from '@funnels/utils';

export function getProductPreferenceExitStrategyInitialValues(formValues: AnyFormValues) {
  const currentRepaymentOptions = get(formValues, FIELD_PATHS.PRODUCT_PREFERENCE_REPAYMENT_OPTIONS(0), []);
  const hasPastGovernmentRetirementAge = get(formValues, FIELD_PATHS.FINANCIAL_SITUATIONS(), []).some(
    (financialSituation: FinancialSituation) =>
      get({ financialSituations: [financialSituation] }, FIELD_PATHS.FINANCIAL_SITUATION_RETIREMENTDETAILS_AGE(0)) >
      GOVERNMENT_RETIREMENT_AGE
  );

  const pastGovernmentRetirementAgeSelected = currentRepaymentOptions.some(
    (repaymentOption: RepaymentOptions) =>
      get(
        { productPreferences: [{ repaymentOptions: [repaymentOption] }] },
        FIELD_PATHS.PRODUCT_PREFERENCE_REPAYMENT_OPTIONS_OPTION(0, 0)
      ) === REPAYMENT_OPTIONS.WorkPastRetirementAge
  );

  if (hasPastGovernmentRetirementAge && !pastGovernmentRetirementAgeSelected) {
    return [
      ...currentRepaymentOptions,
      initialFormValues.INITIAL_PRODUCT_PREFERENCE_REPAYMENT_OPTIONS(REPAYMENT_OPTIONS.WorkPastRetirementAge),
    ];
  }

  return currentRepaymentOptions;
}
